import './SuggestionsOverlay.css';
import '../../../core/components/app-root/AppRoot.css';
import '../../../core/styles/virtualFocus.css';
import './Suggestion.css';
import './SuggestionGroup.css';
export var builtInSuggestionsContainer = '_5cheea0-3-12-1';
export var groupHeaderSeparator = '_5cheea1-3-12-1';
export var suggestionGroup = '_5cheea2-3-12-1';